<template>
  <a-modal
    v-model="visible"
    :title="modalTitle"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    :width="800"
    @ok="
      () => {
        formType === 'add' ? addAction() : editSubmit();
      }
    "
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    centered
  >
    <a-form-model
      :model="form"
      :rules="rules"
      ref="configUpdate"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 17 }"
    >
      <a-form-model-item :label="$t('deviceModel_form_model')" prop="devModelId" class="tree-multi">
        <a-tree-select
          v-model="form.devModelId"
          style="width: 100%;"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="modelList"
          :placeholder="$t('deviceModel_form_model_all')"
          tree-default-expand-all
          size="small"
          :replaceFields="{
            children: 'children',
            title: 'name',
            key: 'devModelId',
            value: 'devModelId',
          }"
          show-search
          allowClear
          :filter-tree-node="filterTreeNode"
          searchPlaceholder="input model name"
          tree-checkable
          treeCheckStrictly
          v-if="modelList && modelList.length"
          :disabled="formType === 'edit'"
        >
        </a-tree-select>
      </a-form-model-item>

      <!-- 配置所属组 -->
      <a-form-model-item :label="$t('deviceModel_form_config_group')" prop="groupId">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.groupId"
          show-search
          :placeholder="$t('deviceModel_form_config_group_placeholder')"
          :filter-option="filterOption"
          @change="groupChange()"
          style="width:100%;"
          allowClear
        >
          <a-select-option v-for="group in groupList" :key="group.groupId" :value="group.groupId">
            {{ group.groupName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 配置名称 -->
      <a-form-model-item
        :label="$t('deviceModel_form_config_item')"
        prop="dictId"
        v-if="form.groupId"
      >
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.dictId"
          show-search
          :placeholder="$t('deviceModel_form_config_item_placeholder')"
          style="width:100%;"
          :filter-option="filterOption"
          allowClear
          :disabled="configLoading"
        >
          <a-icon slot="suffixIcon" type="loading" v-if="configLoading" />
          <a-select-option
            v-for="config in groupConfigList"
            :key="config.dictId"
            :value="config.dictId"
          >
            {{ config.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 协议key -->
      <a-form-model-item
        :label="$t('deviceModel_form_protocol')"
        prop="dataSrc"
        extra="Not allow: space,(),*,?"
      >
        <a-input
          v-model="form.dataSrc"
          :placeholder="$t('deviceModel_form_protocol_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 显示顺序 -->
      <a-form-model-item
        :label="$t('deviceModel_form_display_priority')"
        prop="displayPrio"
        help="Only numerical values are allowed"
      >
        <a-input-number
          v-model="form.displayPrio"
          :placeholder="$t('deviceModel_form_display_priority_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 读取数据权限级别 -->
      <a-form-model-item
        :label="$t('deviceModel_form_data_read_level')"
        prop="rlevel"
        help="Only numerical values are allowed"
      >
        <a-input-number
          v-model="form.rlevel"
          :placeholder="$t('deviceModel_form_data_read_level_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 写入数据权限级别 -->
      <a-form-model-item
        :label="$t('deviceModel_form_data_write_level')"
        prop="wlevel"
        v-if="updateType === 'params'"
      >
        <a-input-number
          v-model="form.wlevel"
          :placeholder="$t('deviceModel_form_data_write_level_placeholder')"
          allowClear
          @input="formInput"
          style="width:100%;"
        />
      </a-form-model-item>

      <!-- 是否可输入 -->
      <a-form-model-item
        :label="$t('deviceModel_form_input')"
        prop="inputable"
        v-if="updateType === 'config'"
      >
        <a-switch v-model="form.inputable" />
      </a-form-model-item>

      <!-- 是否可批量 -->
      <a-form-model-item
        :label="$t('deviceModel_form_batch_support')"
        prop="isSetBatchSupport"
        v-if="updateType === 'params'"
      >
        <a-switch v-model="form.isSetBatchSupport" />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>

    <a-modal
      v-model="resultVisible"
      :title="$t('com_msg_result')"
      centered
      :bodyStyle="{ padding: 0 }"
      :closable="false"
      :maskClosable="false"
    >
      <ul class="add-result">
        <li v-for="key in Object.keys(tipList)" :key="key">
          <span>{{ tipList[key].name }}<i>:</i></span>
          <span v-if="tipList[key].result" style="color:green">
            {{ $t('com_msg_success') }}
          </span>
          <span v-else style="color:#f00"> {{ $t('com_msg_fail') }}</span>
        </li>
      </ul>

      <template #footer>
        <a-button
          type="default"
          @click="
            () => {
              resultVisible = false;
              visible = false;
            }
          "
        >
          {{ $t('com_btn_iknown') }}
        </a-button>
      </template>
    </a-modal>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/model';
import * as APIConfig from '@/api/system/config';
import { checkDataSrcKey } from '@/libs/validator';
import commonMixin from '@/mixins/common';
import { mapGetters } from 'vuex';

export default {
  mixins: [commonMixin],
  props: {
    updateType: {
      type: String,
      default: 'config',
    },
    groupList: {
      type: Array,
      default: () => [],
    },

    callback: {
      type: Function,
      default: () => {},
    },
    modelList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modelInfo: null,
      currentInfo: null,

      currentItemType: null,

      // 配置列表（根据分组ID暂存）
      configLoading: false,
      configList: {
        // 1:[{name:'confit item1'}]
      },

      // 当前组别配置列表
      groupConfigList: [],

      // 新增
      visible: false,
      rules: {
        groupId: [
          {
            required: true,
            message: this.$t('deviceModel_form_config_group_placeholder'),
            trigger: 'change',
          },
        ],
        dictId: [
          {
            required: true,
            message: this.$t('deviceModel_form_config_item_placeholder'),
            trigger: 'change',
          },
        ],
        dataSrc: [
          {
            required: true,
            message: this.$t('deviceModel_form_protocol_placeholder'),
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (checkDataSrcKey(value)) {
                callback();
              } else {
                callback('format error');
              }
            },
            trigger: 'change',
          },
        ],
        rlevel: [
          {
            required: true,
            message: this.$t('deviceModel_form_data_read_level_placeholder'),
            trigger: 'change',
          },
        ],
        wlevel: [
          {
            required: true,
            message: this.$t('deviceModel_form_data_write_level_placeholder'),
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (value < this.userInfo.role.paramWriteLevel && value !== -1) {
                callback(
                  `${this.$t('deviceModel_form_data_write_tips')} ${
                    this.userInfo.role.paramWriteLevel
                  }`
                );
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },

      // 表单
      form: {
        devModelId: undefined,
        groupId: undefined,
        dictId: undefined,
        inputable: undefined,
        dataSrc: undefined,
        displayPrio: undefined,
        rlevel: undefined,
        wlevel: undefined,
        isSetBatchSupport: undefined,
      },

      formError: '',
      formType: '',
      formLoading: false,
      formFork: false,

      // 上传图片
      fileList: [],
      uploading: false,

      // 批量提示
      tipList: [],
      modelSelected: [],
      resultVisible: false,
    };
  },

  computed: {
    ...mapGetters(['userInfo']),
    modalTitle() {
      if (this.formType === 'edit') {
        if (this.updateType === 'config') {
          return this.$t('deviceMode_config_edit_title');
        } else {
          return this.$t('deviceMode_params_edit_title');
        }
      } else {
        if (this.formFork) {
          if (this.updateType === 'config') {
            return this.$t('deviceMode_config_fork_title');
          } else {
            return this.$t('deviceMode_params_fork_title');
          }
        } else {
          if (this.updateType === 'config') {
            return this.$t('deviceMode_config_add_title');
          } else {
            return this.$t('deviceMode_params_add_title');
          }
        }
      }
    },
  },
  methods: {
    // 父模型过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 更新列表
    updateList() {
      // 更新列表
      this.callback(this.updateType);
    },

    //  - 显示
    show(model, currentItem, fork) {
      this.visible = true;
      this.modelInfo = model;
      this.currentInfo = currentItem;
      this.formType = currentItem && !fork ? 'edit' : 'add';
      this.formError = '';
      this.formFork = fork;

      // focus name
      this.$nextTick(() => {
        this.formReset();

        // 默认至少选中当前Model
        if (model && model.devModelId) {
          this.form.devModelId = [{ name: model.name, value: model.devModelId }];
        }

        if (this.formType === 'edit' || this.formFork) {
          this.form = {
            devModelId: [{ name: model.name, value: model.devModelId }],
            groupId: currentItem.groupId,
            dictId: currentItem.dictId,
            inputable: currentItem.input,
            dataSrc: currentItem.dataSrc,
            displayPrio: currentItem.displayPrio,
            rlevel: currentItem.rlevel,
            wlevel: currentItem.wlevel,
            isSetBatchSupport: currentItem.setBatchSupport,
          };

          this.groupChange(true);
        }
      });
    },

    groupChange(edit) {
      this.groupConfigList = [];
      this.getConfigListByGroup();
      if (!edit) {
        this.form.dictId = undefined;
      }
    },

    // 根据group获取匹配列表
    getConfigListByGroup() {
      const groupId = this.form.groupId;
      // 如果缓存中已经存在，不再请求
      if (this.configList[groupId]) {
        this.groupConfigList = this.configList[groupId];
        return;
      }
      this.configLoading = true;
      APIConfig.ConfigGroupItemList({ groupId: groupId })
        .then(res => {
          if (res.code === 0) {
            this.configList[groupId] = res.data;
            this.groupConfigList = res.data;
          }
        })
        .finally(() => {
          this.configLoading = false;
        });
    },

    //  - 提交
    addAction() {
      this.$refs.configUpdate.validate(valid => {
        if (valid) {
          const allDevMOdelIds = this.form.devModelId.map(item => item.value);

          allDevMOdelIds.reduce((t, currentValue) => {
            t = t.then(() => this.asyncfunc(currentValue));
            return t;
          }, Promise.resolve());
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    asyncfunc(devModelId) {
      return new Promise((resolve, _reject) => {
        this.addSubmit(devModelId).then(() => {
          resolve();
        });
      });
    },

    addSubmit(devModelId) {
      this.formLoading = true;
      const allDevMOdelIds = this.form.devModelId.map(item => item.value);

      const params = {
        ...this.form,
        devModelId: devModelId,
      };

      const isLastOne = devModelId === allDevMOdelIds[allDevMOdelIds.length - 1];
      const isSingle = allDevMOdelIds.length === 1;
      const isMulti = allDevMOdelIds.length > 1;

      // 添加配置
      if (this.updateType === 'config') {
        return API.DeviceConfigAdd(params)
          .then(res => {
            if (res.code === 0) {
              this.tipList[devModelId] = { result: true };
              if (isSingle) {
                this.$message.success(this.$t('com_msg_add_success'));
              }

              if (isLastOne) {
                // 多个的时候才modal提示
                if (isMulti) {
                  this.submitTip();
                }
                this.formReset();
                // 更新列表
                this.updateList();
                if (isSingle) {
                  this.visible = false;
                }
              }
            } else {
              this.formLoading = false;
              this.formError = res.message;
            }
          })
          .finally(() => {
            // 失败
            if (!this.tipList[devModelId]) {
              this.tipList[devModelId] = { result: false };
            }

            if (isLastOne) {
              this.formLoading = false;
            }
          });
      } else {
        delete params.inputable;

        // 添加参数
        return API.DeviceModelParamAdd(params)
          .then(res => {
            if (res.code === 0) {
              this.tipList[devModelId] = { result: true };
              if (isSingle) {
                this.$message.success(this.$t('com_msg_add_success'));
              }

              if (isLastOne) {
                // 多个的时候才modal提示
                if (isMulti) {
                  this.submitTip();
                }

                this.formReset();
                // 更新列表
                this.updateList();
                if (isSingle) {
                  this.visible = false;
                }
              }
            } else {
              this.formLoading = false;
              this.formError = res.message;
            }
          })
          .finally(() => {
            // 失败
            if (!this.tipList[devModelId]) {
              this.tipList[devModelId] = { result: false };
            }

            if (isLastOne) {
              this.formLoading = false;
            }
          });
      }
    },

    //提交提示
    submitTip() {
      this.form.devModelId.forEach(item => {
        if (this.tipList[item.value]) {
          this.tipList[item.value].name = item.label;
        }
      });
      this.resultVisible = true;
    },

    //  - error reset
    formInput() {
      this.formError = '';
    },
    //  - add form reset
    formReset() {
      this.$refs.configUpdate.resetFields();
      this.form = {
        groupId: undefined,
        dictId: undefined,
        inputable: undefined,
        dataSrc: undefined,
        displayPrio: undefined,
        rlevel: undefined,
        wlevel: undefined,
        isSetBatchSupport: undefined,
      };
    },

    //  - 提交
    editSubmit() {
      this.$refs.configUpdate.validate(valid => {
        if (valid) {
          this.formLoading = true;

          const params = {
            ...this.form,
            devModelId: this.modelInfo.devModelId,
            id: this.currentInfo.id,
          };

          // 编辑配置
          if (this.updateType === 'config') {
            API.DeviceConfigEdit(params)
              .then(res => {
                if (res.code === 0) {
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formLoading = false;
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            delete params.inputable;
            API.DeviceModelParamEdit(params)
              .then(res => {
                if (res.code === 0) {
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formLoading = false;
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;

  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}

.add-result {
  margin: 0;
  max-height: 196px;

  li {
    border-bottom: #eee solid 1px;
    padding: 10px 0;
    display: flex;

    &:last-child {
      border: none;
    }

    span {
      padding: 0;
      color: #999;
      display: block;
      width: 50%;
      text-align: left;

      &:first-child {
        text-align: right;
      }

      i {
        padding: 0 5px;
        font-style: normal;
      }
    }
  }
}
</style>
